import React, { useState, useEffect } from 'react';
import { createPortal } from "react-dom";
interface LightboxProps {
  images: string[];
  initialIndex: number;
  onClose: () => void;
}

const Lightbox: React.FC<LightboxProps> = ({ images, initialIndex, onClose }) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  // Fermeture avec la touche Echap
  useEffect(() => {
  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === "Escape") onClose();
    if (e.key === "ArrowRight") nextImage();
    if (e.key === "ArrowLeft") prevImage();
  };

  // Lock scroll
  document.body.style.overflow = "hidden";

  window.addEventListener("keydown", handleKeyDown);

  return () => {
    window.removeEventListener("keydown", handleKeyDown);

    // Restore scroll
    document.body.style.overflow = "auto";
  };
}, []);

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return createPortal(
  <div
    className="fixed inset-0 bg-black/95 z-[9999] flex items-center justify-center"
    onClick={onClose}
  >
    <div
      className="relative max-w-5xl w-full mx-4"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Image principale */}
      <img
        src={images[currentIndex]}
        alt={`Vue ${currentIndex + 1}`}
        className="w-full h-auto max-h-[80vh] object-contain"
      />

      {/* Boutons */}
      {images.length > 1 && (
        <>
          <button
            onClick={prevImage}
            className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/40 text-white w-10 h-10 rounded-full flex items-center justify-center"
          >
            ‹
          </button>
          <button
            onClick={nextImage}
            className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/40 text-white w-10 h-10 rounded-full flex items-center justify-center"
          >
            ›
          </button>
        </>
      )}

      {/* Miniatures */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 bg-black/60 p-2 rounded">
        {images.map((img, idx) => (
          <button
            key={idx}
            onClick={() => setCurrentIndex(idx)}
            className={`w-12 h-12 border-2 ${
              idx === currentIndex ? "border-gold" : "border-transparent"
            }`}
          >
            <img
              src={img}
              alt={`mini ${idx + 1}`}
              className="w-full h-full object-cover"
            />
          </button>
        ))}
      </div>

      {/* Close */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white bg-black/50 w-10 h-10 rounded-full text-xl"
      >
        ✕
      </button>
    </div>
  </div>,
  document.body
);
};

export default Lightbox;